(function() {

    angular
        .module('app')
        .directive('ngPrint', ngPrint);
    	ngPrint.$inject = [];

        	function ngPrint() {
			    return {
			        restrict: 'E',
		            template: '<a href="#"><i class="icon icon-imprimir-pantalla"></i> <span>Imprimir</span></a>',
			        link: function ( scope, elem, attrs ) {
			            
			        }
			    };
			}


})();
